if (typeof CollectionTabs !== 'function') {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll('.tabs__list .tabs__item');
      this.panels = this.querySelectorAll('.collection-tabs__content .tabs__content');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.changeTab(tab));
      });
    }

    changeTab(tab) {
      return () => {
        const target = tab.getAttribute('data-tab-target');
        this.panels.forEach((panel) => {
          if (panel.id === target) {
            panel.classList.add('tabs__content--active');
          } else {
            panel.classList.remove('tabs__content--active');
          }
        });
        this.tabs.forEach((tab) => {
          if (tab.getAttribute('data-tab-target') === target) {
            tab.classList.add('tabs__item--active');
          } else {
            tab.classList.remove('tabs__item--active');
          }
        });
      };
    }
  }
  if (typeof customElements.get('collection-tabs') == 'undefined') {
    customElements.define('collection-tabs', CollectionTabs);
  }
}
